var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"inputdir",staticClass:"inputfile",attrs:{"id":"directory","type":"file","name":"file","webkitdirectory":"","disabled":_vm.disabled},on:{"change":_vm.inputLoadDirectories}})}
var staticRenderFns = []

export { render, staticRenderFns }